<!-- 巡检项管理（巡检工单模块） -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove } from "./api";
export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, add, update, remove },
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: "巡检项编码",
            prop: "itemsCode",
            maxlength: 20,
            overHidden: true,
            rules: [
              {
                required: true,
                message: "请输入巡检项编码",
                trigger: "blur",
              },
            ],
          },
          {
            label: "巡检项名称",
            prop: "itemsName",
            maxlength: 100,
            search: true,
            rules: [
              {
                required: true,
                message: "请输入巡检项名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            span: 24,
            minRows: 3,
            maxRows: 6,
            maxlength: 200,
            overHidden: true,
          },
        ],
      },
    };
  },
};
</script>

<style scoped lang="scss"></style>
